import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class LogicBranchProps {
  @Inlet(Accepts.LogicBranchType) public type?: Types["LogicBranchType"];

  @Inlet(Accepts.LogicBranchScoringOptionList)
  public scoringOptions?: Types["LogicBranchScoringOptionList"];

  @Inlet(Accepts.LogicBranchLogicOptionList)
  public logicOptions?: Types["LogicBranchLogicOptionList"];

  @Inlet(Accepts.LogicBranchLogicOption)
  public logicFallback?: Types["LogicBranchLogicOption"];
}

export const LogicBranchDefinition = defineElement(
  "logic-branch",
  LogicBranchProps,
  {
    versionRequired: "0.58.0",
  }
);
